module.exports = __webpack_public_path__ + "img/item-2.bbe45e5f.svg";